export default {
    state: {
        brand_id: null,
        brands: [],
        brand: [],
        errors: {},
        form: {
            code: '',
            name: '',
            image: '',
            description: '',
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'description', label: 'Description', tdClass: 'text-muted'},
                {key: 'image', label: 'Image', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },

        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },

    },

    getters: {
        getProductBrandTableFields: state => state.table.fields,

        getProductBrandMeta: state => state.meta,

        getProductBrandForm: state => state.form,

        getProductBrandErrors: state => state.errors,
    },

    mutations: {
        resetProductBrandsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setProductBrandForm: state => {
            state.form = {
                code: '',
                name: '',
                image: '',
                description: '',
            };

            state.errors = {};
        },

        setProductBrands: (state, payload) => {
            state.brands = payload;
        },

        setProductBrandsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setProductBrandErrors: (state, payload) => {
            state.errors = payload;
        },

    },

    actions: {
        fetchProductBrands: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const brands = {
                "data": [
                    {
                        "brand_id": 1,
                        "label": "Mobile1",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile1",
                                "description": "test-q",
                                "image": "image3.jpg",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "brands\/1"}
                    },
                    {
                        "brand_id": 2,
                        "label": "Mobile2",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Mobile2",
                                "description": "test-a",
                                "image": "image1.jpg",
                                "status": "Inactive"
                            }
                        },
                        "links": {"self": "brands\/2"}
                    },
                    {
                        "brand_id": 3,
                        "label": "Mobile3",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Mobile3",
                                "description": "test-z",
                                "image": "image2.jpg",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "brands\/3"}
                    }
                ],
                "links": {
                    "self": "\/brands",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/brands?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/brands",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setProductBrands', brands);

                commit('setProductBrandsMeta', brands.meta);

                resolve(brands);
            });
        },

        fetchEditProductBrand: ({state, commit}, brand_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + brand_id + '/edit')
                    .then(response => {
                        state.brand_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitProductBrand: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductBrandErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateProductBrand: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.brand_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductBrandErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteBrand: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.brand_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

    }
}
